module.exports = __webpack_public_path__ + "static/media/EAI-06.939c1f4f.jpg";